import { render, staticRenderFns } from "./EditStudent.vue?vue&type=template&id=0ebbc70c"
import script from "../../services/student/edit-student.js?vue&type=script&lang=js&external"
export * from "../../services/student/edit-student.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/student/edit-student.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports